
<script setup lang="ts">
import { useHead } from "@vueuse/head"
  const head = {"title":"Deklaracja Dostępności | Sigma Clinic","meta":[{"property":"og:title","content":"Deklaracja Dostępności | Sigma Clinic"},{"property":"og:description","content":"Deklaracja dostępności serwisu Sigma Clinic."},{"name":"description","content":"Deklaracja dostępności serwisu Sigma Clinic."}]}
  useHead(head)
  const title = "Deklaracja Dostępności | Sigma Clinic"
 const description = "Deklaracja dostępności serwisu Sigma Clinic."
 const excerpt = undefined
 const meta = [{"property":"og:title","content":"Deklaracja Dostępności | Sigma Clinic"},{"property":"og:description","content":"Deklaracja dostępności serwisu Sigma Clinic."},{"name":"description","content":"Deklaracja dostępności serwisu Sigma Clinic."}]
  defineExpose({ frontmatter: {"title":"Deklaracja Dostępności | Sigma Clinic","description":"Deklaracja dostępności serwisu Sigma Clinic.","meta":[{"property":"og:title","content":"Deklaracja Dostępności | Sigma Clinic"},{"property":"og:description","content":"Deklaracja dostępności serwisu Sigma Clinic."},{"name":"description","content":"Deklaracja dostępności serwisu Sigma Clinic."}]}, excerpt: undefined })
</script>
<script lang="ts">
/** frontmatter meta-data for MD page **/
export interface Frontmatter {
  title?: string
  description?: string
  subject?: string
  category?: string
  name?: string
  excerpt?: string
  image?: string
  layout?: string
  requiredAuth?: boolean
  meta?: Record<string, any>[]
  [key: string]: unknown
}
export const frontmatter: Frontmatter = {"title":"Deklaracja Dostępności | Sigma Clinic","description":"Deklaracja dostępności serwisu Sigma Clinic.","meta":[{"property":"og:title","content":"Deklaracja Dostępności | Sigma Clinic"},{"property":"og:description","content":"Deklaracja dostępności serwisu Sigma Clinic."},{"name":"description","content":"Deklaracja dostępności serwisu Sigma Clinic."}]}
export const excerpt: string | undefined = ""

</script>
<template>
<div class="markdown-body"><h1>Accessibility Statement</h1>
<h3>Pre‑launch notice</h3>
<p><em>The Service is not yet available in Poland. This page is provided for informational purposes only. These terms/policies will take effect on the public launch date.</em></p>
<p><strong>Last updated:</strong> September 8, 2025<br>
<strong>Contact:</strong> support@sigma.clinic</p>
<h2>Our commitment</h2>
<p>We aim to make our website and app usable by as many people as possible and to align with <strong>WCAG 2.1 AA</strong>.</p>
<h2>Measures</h2>
<p>Semantic HTML; keyboard navigation; visible focus states; sufficient contrast; screen-reader compatibility (landmarks, labels, alt text); responsive layouts; text-resizing support; periodic reviews; potential external audit.</p>
<h2>Feedback &amp; contact</h2>
<p>If you encounter an accessibility barrier, contact <strong>support@sigma.clinic</strong>. We aim to respond within <strong>14 days</strong>.</p>
<h2>Assessment method</h2>
<p>Self-assessment.<br>
<strong>Known limitations:</strong> Minor issues may remain; we prioritize fixes by user impact.</p>
</div>
</template>
